// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._487715{display:grid;grid-template-columns:1fr 1fr 1fr;gap:1em}._487715>*{margin:0}._8f662b{display:flex;align-items:flex-end}._8f662b>div:first-child{padding-top:var(--medium-spacer)}._8f662b .e34cd6{font-size:.875em}._92a6c6{background:var(--white);font-weight:600;text-align:center;padding:1em .5em;border-radius:.5em;white-space:nowrap;margin-top:50%}._92a6c6._8f662b{margin-top:calc(11vh - 1em);background:var(--snow)}.d2ec01{text-decoration:line-through;opacity:.5;animation:_1e09e2 .2s}@keyframes _1e09e2{50%{transform:scale(1.0125)}}", ""]);
// Exports
exports.locals = {
	"grid": "_487715",
	"project": "_8f662b",
	"toolbar": "e34cd6",
	"label": "_92a6c6",
	"deleted": "d2ec01",
	"bounce": "_1e09e2"
};
module.exports = exports;
